<template>
	<div class="work cursor" @click.stop="state">
		<i :class="currentState.icons"></i>
		<span v-loading="updStateLoading">
			{{currentState.status}}
			(
			<span style="color: #0f7df3;font-weight: 500;">
				<chronograph :countVals="currentState.currentTime" :isStarts="isStart" />
			</span>
			)
		</span>
		<i class="iconfont icon-down"></i>
		<ul class="dropdown-menu fadeInDown" v-if="show1">
			<li :key="index" v-for="(item,index) in userStates" @click="selectedStates(item)">
				<i :class="item.icon"></i>
				{{item.name}}
			</li>
		</ul>
	</div>
</template>
<script>
import chronograph from './chronograph'
export default {
	name: 'stateTimer',
	props: [],
	data() {
		return {
			userStates: [],
			currentState: {
				id: 2,
				icons: 'iconfont  icon-qianchu',
				status: '迁出',
				currentTime: 0
			},
			show1: false,
			isStart: false,
			updStateLoading: false
		}
	},
	mounted: function() {
		this.getUserStates() //初始化
	},
	methods: {
		getUserStates() {
			//初始化报表
			let vm = this
			this.axios.get('User/GetUserStates').then(function({ data }) {
				if (data.result) {
					vm.userStates = data.data
					vm.updStateLoading = true
					vm.initState() //初始化数据
				}
			})
		},
		selectedStates(item) {
			let vm = this
			this.axios
				.get('user/updUserState', { params: { state: item.id } })
				.then(function({ data }) {
					if (data.result) {
						vm.currentState.id = item.id
						vm.currentState.icons = item.icon
						vm.currentState.status = item.name
						vm.currentState.currentTime = data.data
					} else {
						vm.$confirm(data.message, '提示', {
							confirmButtonText: '确定',
							type: 'error',
							showCancelButton: false
						})
					}
				})
		},
		initState() {
			let vm = this
			this.axios.get('user/CheckUserState').then(function({ data }) {
				if (data.result) {
					let obj = vm.userStates.find(d => d.id == data.data.stateId)
					if (obj != undefined) {
						vm.currentState.id = obj.id
						vm.currentState.icon = obj.icon
						vm.currentState.status = obj.name
						vm.currentState.currentTime = data.data.millisecond
						vm.isStart = true
					}
					vm.updStateLoading = false
				}
			})
		},
		state(data) {
			if (this.show1) {
				this.show1 = false
			} else {
				this.show1 = true
				this.show = false
			}
		},
		setUpMoveOut() {
			//设置为迁出
			let obj = this.userStates.find(d => d.id == 2)
			this.selectedStates(obj)
		}
	},
	components: {
		chronograph
	}
}
</script>

<style scoped>
.work {
	position: relative;
	z-index: 50;
}
.iconfont {
	cursor: pointer;
}
.dropdown-menu {
	width: 130px;
	position: absolute;
	padding: 6px 0px;
	background-color: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	-o-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(0, 0, 0, 0.15);
	list-style: none;
	top: 62px;
	left: 50%;
	margin-left: -72px;
	border-radius: 3px;
	z-index: 99;
}
.work .dropdown-menu {
	width: 100px;
	left: 50%;
	margin-left: -52px;
}

.dropdown-menu:before {
	position: absolute;
	right: 65px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}

.work .dropdown-menu:before {
	position: absolute;
	right: 41px;
	top: -5px;
	content: '';
	z-index: 1;
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 6px solid #fff;
}

.dropdown-menu li {
	text-align: center;
	line-height: 40px;
}

.dropdown-menu li:hover {
	line-height: 40px;
	background-color: #409eff;
	color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/customers/stateTimer.vue